export { default as collectionSlice, setCollection } from './collection.slice'